import axios from '@/axios'
import * as types from '../mutation-types'
export default {
    namespaced: true,

    state: {
        reminders: []
    },

    actions: {
        fetchAll({ commit }, { employeeId, sectionId, reminderTypeId, date }) {
            return axios.get('/reminder', {
                params: { employeeId, sectionId, reminderTypeId, date }
            }).then(({ data }) => {
                commit(types.STORE_REMINDERS, data);
                return data;    
            })
        },

        create(_, { employeeId, sectionId, reminderTypeId, date, notes }) {
            return axios.post('/reminder', { employeeId, sectionId, reminderTypeId, date, notes });
        },
        update(_, { id, employeeId, sectionId, reminderTypeId, date, notes }) {
            return axios.put(`/reminder/${id}`, { employeeId, sectionId, reminderTypeId, date, notes });
        },
        delete(_, { id }) {
            return axios.delete(`/reminder/${id}`);
        },
    },

    mutations: {
        [types.STORE_REMINDERS](state, reminders) {
            state.reminders = reminders;
        }
    },

    getters: {
        getReminderById: state => id => state.reminders.find(c => c.id === id)
    }
}